// Příloha jako v demu: obrázek je čtvercový náhled (klik = zvětšit), ostatní soubory ikona podle typu a název.
// Křížek pro odebrání se ukáže při najetí (na dotykových zařízeních vždy).
import { useState } from 'react';
import { XIcon } from '@phosphor-icons/react';
import { Modal, Spinner } from '@smworks-cz/ui-kit';
import { fileKind, fmtSize } from '../lib/files';

export function FileIcon({ name, mime }: { name: string; mime: string }) {
  const k = fileKind(name, mime);
  const lab = k.label.length > 4 ? k.label.slice(0, 4) : k.label;
  return (
    <svg viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path d="M10 3.5h13.5L31 11v23.5a2 2 0 01-2 2H10a2 2 0 01-2-2v-29a2 2 0 012-2z" fill={k.color} fillOpacity="0.16" stroke={k.color} strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M23.5 3.5V11H31" stroke={k.color} strokeWidth="1.6" strokeLinejoin="round" />
      <text x="19.5" y="29" textAnchor="middle" fontSize={lab.length > 3 ? 8 : 9.5} fontWeight="700" fill={k.color} fontFamily="Zalando Sans Expanded, sans-serif">
        {lab}
      </text>
    </svg>
  );
}

interface Props {
  name: string;
  mime: string;
  size: number;
  /** Adresa náhledu (objectURL při nahrávání, /api/files/:id u odeslaných). */
  src?: string | null;
  uploading?: boolean;
  error?: string | null;
  big?: boolean;
  onRemove?: () => void;
}

export function AttachmentTile({ name, mime, size, src, uploading, error, big, onRemove }: Props) {
  const [zoom, setZoom] = useState(false);
  const k = fileKind(name, mime);
  const remove = onRemove && (
    <button type="button" className="att-x" onClick={onRemove} aria-label={`Odebrat přílohu ${name}`} title="Odebrat">
      <XIcon size={12} weight="bold" />
    </button>
  );
  const busy = uploading && (
    <span className="att-busy" aria-label="Nahrávám">
      <Spinner size={16} />
    </span>
  );
  if (k.image && src) {
    return (
      <div className={`att${big ? ' big' : ''}${error ? ' is-error' : ''}`} title={error ?? name}>
        <button type="button" className="att-tile" onClick={() => setZoom(true)} aria-label={`Zvětšit náhled ${name}`}>
          <img src={src} alt="" />
          {busy}
        </button>
        {remove}
        <Modal open={zoom} onClose={() => setZoom(false)} title={name} size="xl">
          <img className="att-zoom" src={src} alt={name} />
        </Modal>
      </div>
    );
  }
  const body = (
    <>
      <span className="att-tile">
        <FileIcon name={name} mime={mime} />
        {busy}
      </span>
      <span className="att-name">
        <b title={name}>{name}</b>
        <small>{error ?? `${k.label}${size ? ` · ${fmtSize(size)}` : ''}`}</small>
      </span>
    </>
  );
  return (
    <div className={`att file${error ? ' is-error' : ''}`}>
      {src && !uploading ? (
        <a className="att-link" href={src} download={name}>
          {body}
        </a>
      ) : (
        body
      )}
      {remove}
    </div>
  );
}
